"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProviderReplacementPaths = exports.EProviderStates = void 0;
var EProviderStates;
(function (EProviderStates) {
    EProviderStates["inactive"] = "inactive";
    EProviderStates["active"] = "active";
    EProviderStates["connecting"] = "connecting";
    EProviderStates["disconnecting"] = "disconnecting";
    EProviderStates["stopped"] = "stopped";
    EProviderStates["error-code"] = "error-code";
    EProviderStates["error-connection"] = "error-connection";
    EProviderStates["half-open"] = "half-open";
})(EProviderStates || (exports.EProviderStates = EProviderStates = {}));
var EProviderReplacementPaths;
(function (EProviderReplacementPaths) {
    EProviderReplacementPaths["payload.text"] = "payload.text";
    EProviderReplacementPaths["payload.sender"] = "payload.sender";
})(EProviderReplacementPaths || (exports.EProviderReplacementPaths = EProviderReplacementPaths = {}));
//# sourceMappingURL=provider-crud.enum.js.map